// Shared display labels for the three role controls (#558 vocabulary).
// Single source for UserFormDialog, AdminOrganizationPage and any future
// role UI — keeps the dialog preview and the save-verdict toasts in lockstep.
// NOTE: imports PILLAR_DEFS (which pulls lucide-react icons) — component-side
// only; utils/orgRoles.js stays dependency-free for hermetic jest suites.
import { PILLAR_DEFS } from '../config/pillarDefs';

// Work (legacy) role labels — the editable picker values in UserFormDialog.
export const WORK_ROLE_LABELS = { sales_rep: 'Sales Rep', manager: 'Manager', admin: 'Admin' };

// Organization role labels — owner is reserved; legacy 'admin' alias kept.
export const ORG_ROLE_LABELS = { owner: 'Owner', org_admin: 'Org Admin', admin: 'Admin', member: 'Member' };

// Department label lookup by pillar id — unknown ids fall back to the raw id.
export const pillarLabelOf = (id) => (PILLAR_DEFS.find((p) => p.id === id) || {}).label || id;
